module.exports = __webpack_public_path__ + "static/media/hg1.13963bd4.png";